import { render, staticRenderFns } from "./AudioMessage.vue?vue&type=template&id=1f166ae2&scoped=true"
import script from "./AudioMessage.vue?vue&type=script&lang=js"
export * from "./AudioMessage.vue?vue&type=script&lang=js"
import style0 from "./AudioMessage.vue?vue&type=style&index=0&id=1f166ae2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f166ae2",
  null
  
)

export default component.exports